import { Component, computed, effect, inject } from '@angular/core'
import { DomSanitizer, SafeHtml, SafeUrl } from '@angular/platform-browser'
import { RouterLink, RouterLinkActive } from '@angular/router'

import { LogoService } from 'app/_shared/services/logo.service'
import { AppConfigService } from 'app/app-config.service'
import { ConfigStore } from 'app/store/config.store'

@Component({
  selector: 'app-footer',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  configStore = inject(ConfigStore)
  appConfigService = inject(AppConfigService)
  sanitizer = inject(DomSanitizer)
  readonly logo = inject(LogoService)

  trustedHtml: SafeHtml | null = null
  storefrontId = this.appConfigService.getAppConfig?.id
  footerContent = effect(() => {
    const rawFooterContent = this.configStore.config()?.settings?.footerContent ?? ''

    // Replace all non-breaking spaces with regular spaces.
    const normalizedContent = rawFooterContent.replace(/&nbsp;/g, ' ')

    // strip out the HTML tags
    const stripped = rawFooterContent.replace(/<[^>]+>/g, '').trim()

    if (stripped) {
      this.trustedHtml = this.sanitizer.bypassSecurityTrustHtml(normalizedContent)
    } else {
      this.trustedHtml = null
    }
  })

  date = new Date().getFullYear()

  copyright = computed(() => this.configStore.config().settings?.copyrightText ?? '')
  socialLinks = computed(() => this.configStore.config().settings?.socialIcons ?? [])
  protected readonly footerBackgroundColor = computed(
    () => this.configStore.config().settings?.footerBackgroundColor?.trim() || null
  )
  protected readonly footerTextColor = computed(
    () => this.configStore.config().settings?.footerTextColor?.trim() || null
  )

  sanitizeUrl(url: string): SafeUrl {
    // Checks if the URL starts with http:// or https:// (case-insensitive)
    const pattern = /^https?:\/\//i
    const finalUrl = pattern.test(url) ? url : `https://${url}`
    return this.sanitizer.bypassSecurityTrustUrl(finalUrl)
  }

  getSocialIconPath(name: string): SafeUrl {
    const path = `assets/img/icons/social/${name.toLowerCase()}.svg`
    return this.sanitizer.bypassSecurityTrustUrl(path)
  }

  get menuItems() {
    const footerItems = this.configStore.config()?.menu?.filter(item => item.footerVisible) ?? []

    const staticLinks = [
      { label: 'Privacy Policy', item: { url: 'privacy-policy' }, customUrl: '' },
      { label: 'Terms and Conditions', item: { url: 'terms-and-conditions' }, customUrl: '' },
      { label: 'Contact', item: { url: 'contact' }, customUrl: '' }
      // { label: 'FAQ', item: { url: 'faq' }, customUrl: '' },
    ]

    return [...staticLinks, ...footerItems]
  }

  getRouterLink(item): string {
    if (item.item && item.item.url) {
      if (item.item.type && item.item.type === 'category') {
        return '/categories/' + item.item.url
      } else {
        return '/' + item.item.url
      }
    }
    return item.customUrl ?? '/'
  }
}
